import BEMHelper from 'react-bem-helper';

export const bem = BEMHelper({ name: 'AgendaDay', outputIsString: true });
